export default container => {
  const screens = ["mobile", "desktop"];

  screens.forEach(screen => {
    container.style.setProperty(
      `--${screen}-height`,
      window.innerHeight + "px"
    );
  });
};
